export interface UserProps {
  accessToken: string;
  name: string;
  roles: string[];
  groups: string[];
  statuses: Record<string, { count: number; right: number }>;
}
export interface UserState {
  login?: string;
  success: boolean;
  loading: boolean;
  error: string | null;
  loggedIn: boolean | undefined;
  data: UserProps;
}

export enum UserActionTypes {
  POST_USER_LOGIN = "POST_USER_LOGIN",
  POST_USER_TOKEN = "POST_USER_TOKEN",
  POST_USER_INFO_SUCCESS = "POST_USER_INFO_SUCCESS",
  POST_USER_TOKEN_SUCCESS = "POST_USER_TOKEN_SUCCESS",
  POST_USER_TOKEN_ERROR = "POST_USER_TOKEN_ERROR",
  POST_USER_INFO_ERROR = "POST_USER_INFO_ERROR",
  PUT_UPLOAD_DATA_ERROR = "PUT_UPLOAD_DATA_ERROR",
  UPDATE_TOKEN = "UPDATE_TOKEN",
  REMOVE_TOKEN = "REMOVE_TOKEN",
}

interface PostUserLoginAction {
  type: UserActionTypes.POST_USER_LOGIN;
  payload: string;
}

interface PostUserTokenAction {
  type: UserActionTypes.POST_USER_TOKEN;
}

interface PostUserTokenSuccessAction {
  type: UserActionTypes.POST_USER_TOKEN_SUCCESS;
  payload: UserProps;
}

interface PostUserInfoErrorAction {
  type: UserActionTypes.POST_USER_INFO_ERROR;
  payload: string;
}

interface PostUserInfoSuccessAction {
  type: UserActionTypes.POST_USER_INFO_SUCCESS;
  payload: UserProps;
}

interface PostUserTokenErrorAction {
  type: UserActionTypes.POST_USER_TOKEN_ERROR;
  payload: string;
}

interface UpdateTokenAction {
  type: UserActionTypes.UPDATE_TOKEN;
  payload: UserProps;
}

interface RemoveTokenAction {
  type: UserActionTypes.REMOVE_TOKEN;
}

export type usersAction =
  | PostUserLoginAction
  | PostUserTokenAction
  | PostUserInfoSuccessAction
  | PostUserInfoErrorAction
  | PostUserTokenSuccessAction
  | PostUserTokenErrorAction
  | UpdateTokenAction
  | RemoveTokenAction;
